import { useCheckout } from '../../context';

function OrgInfo() {
  const { organization } = useCheckout();

  return (
    <div className="flex flex-1 gap-4 items-center md:w-2/3 px-4">
      <img
        src={organization.badgeImageUrl}
        alt={organization.name}
        className="w-[72px] h-[72px] object-cover rounded-lg border-2 border-white"
      />
      <div className="flex flex-col gap-[2px] md:gap-1">
        <h2 className="text-4xl font-black">{organization.name}</h2>
      </div>
    </div>
  );
}

export default OrgInfo;
